import ModificationLogTypes from './types';

export const fetchModificationLog = ({
    page,
    size,
    operation,
    search,
    timeframe,
}) => ({
    type: ModificationLogTypes.FETCH_MODIFICATION_LOG_START,
    data: { page, size, operation, search, timeframe },
});
export const fetchModificationLogSuccess = (modificationLog) => ({
    type: ModificationLogTypes.FETCH_MODIFICATION_LOG_SUCCESS,
    payload: modificationLog
});
export const fetchModificationLogFailure = (error) => ({
    type: ModificationLogTypes.FETCH_MODIFICATION_LOG_FAILURE,
    payload: error
});